import * as React from "react";
import { OTPInput, OTPInputContext } from "input-otp";
import { MinusIcon } from "lucide-react";

import { cn } from "@/lib/utils";

function InputOTP({
  className,
  containerClassName,
  disabled,
  ...props
}: React.ComponentProps<typeof OTPInput> & {
  containerClassName?: string;
}) {
  return (
    <OTPInput
      data-slot="input-otp"
      containerClassName={cn("wl-input-otp", containerClassName)}
      className={cn("wl-disabled", className)}
      disabled={disabled}
      {...props}
    />
  );
}

function InputOTPGroup({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="input-otp-group"
      className={cn("wl-input-otp-group", className)}
      {...props}
    />
  );
}

function InputOTPSlot({
  index,
  className,
  disabled,
  ...props
}: React.ComponentProps<"input"> & {
  index: number;
}) {
  const inputOTPContext = React.useContext(OTPInputContext);
  const { char, isActive } = inputOTPContext?.slots[index] ?? {};

  return (
    <input
      data-slot="input-otp-slot"
      data-active={isActive}
      data-focused={isActive}
      data-disabled={disabled}
      className={cn("wl-input-otp-slot", className)}
      value={char || ""}
      readOnly
      disabled={disabled}
      {...props}
    />
  );
}

function InputOTPSeparator({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="input-otp-separator"
      role="separator"
      className={cn("wl-input-otp-separator", className)}
      {...props}
    >
      <MinusIcon />
    </div>
  );
}

export { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator };
